<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Salon Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings/Places" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Salonlar</span>
        </b-btn>
      </b-col>
    </b-row>

    <form @submit.prevent="AddPlace">
      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in Place"
        :key="index"
      >
        <b-form-input type="text" v-model="Place[index]" @keypress.enter.prevent="AddPlace"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Salon Adı",
        Sort: "Sıralama"
      },
      Place: {
        Name: "",
        Sort: 0
      }
    };
  },
  computed: {
    ...mapGetters(["GetStoreData"]),
    ...mapState(["ButtonSize"])
  },
  methods: {
    async AddPlace() {
      await this.$store.dispatch("AddLoading", "AddPlace");

      await Services.Nozich.Send(
        "AddPlace",
        {
          Place: this.Place
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddPlace");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Places");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
